var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBrush = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#brush_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  fillRule: "evenodd",
  d: "M6.407.306A.55.55 0 0 1 6.9 0h4.858c.88 0 1.6.72 1.6 1.6v3.8a1 1 0 0 1-1 1h-9.2a1 1 0 0 1-1-1V1.92c0-.787.546-1.92 1.332-1.92h1.41c.253 0 .458.205.458.458 0 .484.652.638.869.205zM2.16 10.4a.16.16 0 0 1-.16-.16V9a1 1 0 0 1 1-1h9.2a1 1 0 0 1 1 1v.4a1 1 0 0 1-1 1h-1.96c-.56 0-.88.48-.8.96l.4 1.6C10.4 14.48 9.2 16 7.68 16s-2.64-1.52-2.16-3.04l.4-1.6c.08-.48-.32-.96-.8-.96zm4.8 3.2c0 .48.32.8.8.8s.8-.32.8-.8-.32-.8-.8-.8-.8.32-.8.8",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "brush_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgBrush;